import { render, staticRenderFns } from "./gebruikers.vue?vue&type=template&id=fa727fc6"
import script from "./gebruikers.vue?vue&type=script&lang=js"
export * from "./gebruikers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports